// extracted by mini-css-extract-plugin
export default {"teamGrid":"TeamGrid_teamGrid__Ch1gE","teamCard":"TeamGrid_teamCard__vo6ZD","cardInfo":"TeamGrid_cardInfo__zF2aR"};